import ArticoloItem from './ArticoloItem';

export default ArticoloItem;
